import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadIncentiveMultipliersActions from "../../store/actions/BulkUploadIncentiveMultipliers"
import BulkUploadFile from "../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <BulkUploadIncentiveMultipliersModal>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BulkUploadIncentiveMultipliersActionsUpload"
        uploadUrl="/incentive-multipliers/bulk-upload/ack"
        sampleURL="/sample/bulk_upload_incentive_multipliers.csv"
        id="bulkUploadIncentiveMultipliersModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Upload Incentive Multipliers"
        useUserUploadedFilename={true}
        getUploadUrl={getUploadUrl}
        validationType="BulkUploadIncentiveMultipliers"
        maxSize={10.0} // in mb
      />
    </BulkUploadIncentiveMultipliersModal>
  )
}

const BulkUploadIncentiveMultipliersModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadIncentiveMultipliersActions.bulkUploadIncentiveMultipliers,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);